import React from 'react';
import { Body1, Title3, makeStyles } from '@fluentui/react-components';
import { customColors, customFonts } from '../../../styles';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100vh',
        gap: '12px',
        padding: '80px',
        boxSizing: 'border-box',
        backgroundColor: customColors.lightBlueGrayBackground1,
        fontFamily: customFonts.Lato,
        textAlign: 'center',
    },
    title: {
        color: customColors.protivitiDarkBlue,
    },
    body: {
        color: customColors.headerLightGray,
        maxWidth: '480px',
    },
});

export const ServiceInterruptionScreen: React.FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Title3 className={classes.title}>ProGPT is currently experiencing interruptions</Title3>
            <Body1 className={classes.body}>
                We were unable to retrieve your chat sessions. Please try again later or contact support.
            </Body1>
        </div>
    );
};

export default ServiceInterruptionScreen;
